import type { PortableTextComponents } from "@portabletext/react";

import { MediaAudio } from "./MediaAudio";
import { MediaImage } from "./MediaImage";
import { MediaVideo } from "./MediaVideo";

/**
 * Renderers for media embedded in `richTextBody` body copy.
 *
 * Supplied by the app rather than defaulted inside `packages/ui` because all
 * three resolve Sanity asset URLs, which needs the project-configured client.
 * `richTextColumns` is a `packages/ui` default and is deliberately absent here;
 * its cells inherit this map, so media inside a column still renders.
 */
function createMediaRichTextComponents(): Partial<PortableTextComponents> {
  return {
    types: {
      mediaAudio({ value }) {
        return <MediaAudio {...value} />;
      },
      mediaImage({ value }) {
        return <MediaImage {...value} />;
      },
      mediaVideo({ value }) {
        return <MediaVideo {...value} />;
      },
    },
  };
}

export { createMediaRichTextComponents };
